export default __webpack_public_path__ + "static/bg_image_other@2x-b6c0588ed404d2ab27bbfb4f03f9dd76.jpg";